export const spiritualMaalaLevelThree = [
    {
        "name": "Rudraksh Maala",
        "categoryId": "rudraksh_maala",
        "parentCategoryName": "Maala",
        "parentCategoryId": "maala",
        "level": 3
    },
    {
        "name": "Black Rudraksh Maala",
        "categoryId": "black_rudraksh_maala",
        "parentCategoryName": "Maala",
        "parentCategoryId": "maala",
        "level": 3
    },
    {
        "name": "Karungali Maala",
        "categoryId": "karungali_maala",
        "parentCategoryName": "Maala",
        "parentCategoryId": "maala",
        "level": 3
    },
    {
        "name": "Vaijayanti Maala",
        "categoryId": "vaijayanti_maala",
        "parentCategoryName": "Maala",
        "parentCategoryId": "maala",
        "level": 3
    },
    {
        "name": "Tulsi Maala",
        "categoryId": "tulsi_maala",
        "parentCategoryName": "Maala",
        "parentCategoryId": "maala",
        "level": 3
    },
    {
        "name": "Lal Chandan Maala",
        "categoryId": "lal_chandan_maala",
        "parentCategoryName": "Maala",
        "parentCategoryId": "maala",
        "level": 3
    },
    {
        "name": "Lotus Seed Bead Maala",
        "categoryId": "lotus_seed_bead_maala",
        "parentCategoryName": "Maala",
        "parentCategoryId": "maala",
        "level": 3
    },
    {
        "name": "Narmundi Maala",
        "categoryId": "narmundi_maala",
        "parentCategoryName": "Maala",
        "parentCategoryId": "maala",
        "level": 3
    },
    {
        "name": "Rudraksh Pendant",
        "categoryId": "rudraksh_pendant",
        "parentCategoryName": "Maala",
        "parentCategoryId": "maala",
        "level": 3
    },
    {
        "name": "Sphatik Maala",
        "categoryId": "sphatik_maala",
        "parentCategoryName": "Maala",
        "parentCategoryId": "maala",
        "level": 3
    },
    {
        "name": "Rudraksh Kuntha Maala",
        "categoryId": "rudraksh_kuntha_maala",
        "parentCategoryName": "Maala",
        "parentCategoryId": "maala",
        "level": 3
    },
    {
        "name": "Rudraksh Bracelet",
        "categoryId": "rudraksh_Bracelet",
        "parentCategoryName": "Divine Items",
        "parentCategoryId": "divine_items",
        "level": 3
    },
    {
        "name": "Shankh",
        "categoryId": "shankh",
        "parentCategoryName": "Divine Items",
        "parentCategoryId": "divine_items",
        "level": 3
    },
    {
        "name": "Sandalwood Stick",
        "categoryId": "sandalwood_stick",
        "parentCategoryName": "Divine Items",
        "parentCategoryId": "divine_items",
        "level": 3
    },

]
